import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { Loader } from "./loader";
import {
  currencyFormatter,
  findAllowedPrefixData,
  findCountyLocationData,
  getCountySetupFeeCredit,
  getObjLength,
} from "../helpers/utils";
import auto_activity1 from "../../assets/home/auto_activity_zone.svg";
import auto_activity from "../../assets/home/simple_auto_activity_zone .svg";
import {
  CountyVertical,
  LOCAL_RECORDING_FEES,
  PER_ANNUAL_SAVINGS,
  PER_MONTH_SAVINGS,
} from "../helpers/constants";

import "../../styles/pricing.scss";

const SubscriptionPlansContent = ({
  plan1 = true,
  plan2 = true,
  fullPage = false,
  price,
  county_name = null,
  promoCode = null,
  yearly_spacing = "",
  signup_link = "/create-account",
  is_temp_space = false,
  allowedPrefixObj = {},
  isAdminCreateUser = false,
  isEnhancedMonitoring = false,
}) => {
  const { county_name: county } = useParams();
  const navigate = useNavigate();
  const { subscriptionPlans, statesLoader } = useSelector(
    (state) => state.signUpUser,
  );
  const { brokerDetails } = useSelector((state) => state?.brokerAgents);

  const isFirstYearFreePricing = getObjLength(allowedPrefixObj)
    ? allowedPrefixObj?.isFirstYearFreePricing
    : county_name && findAllowedPrefixData(county_name)?.isFirstYearFreePricing
      ? true
      : false;

  const [MONTHLY_PLAN, set_MONTHLY_PLAN] = useState();
  const [MONTHLY_PLAN_AMOUNT, set_MONTHLY_PLAN_AMOUNT] = useState();
  const [MONTHLY_DISCOUNT_PLAN_AMOUNT, set_MONTHLY_DISCOUNT_PLAN_AMOUNT] =
    useState();
  const [MONTHLY_DISCOUNT_SETUP_AMOUNT, set_MONTHLY_DISCOUNT_SETUP_AMOUNT] =
    useState();
  const [MONTHLY_PLAN_RECORDING_FEES, set_MONTHLY_PLAN_RECORDING_FEES] =
    useState();
  const [MONTHLY_PLAN_PER_MONTH, set_MONTHLY_PLAN_PER_MONTH] = useState();
  const [YEARLY_PLAN, set_YEARLY_PLAN] = useState();
  const [YEARLY_PLAN_PER_MONTH, set_YEARLY_PLAN_PER_MONTH] = useState();
  const [YEARLY_PLAN_RECORDING_FEES, set_YEARLY_PLAN_RECORDING_FEES] =
    useState();
  const [YEARLY_DISCOUNT_PLAN_AMOUNT, set_YEARLY_DISCOUNT_PLAN_AMOUNT] =
    useState();
  const [YEARLY_SAVINGS, set_YEARLY_SAVINGS] = useState();
  const [FIRST_YEAR_SAVINGS, set_FIRST_YEAR_SAVINGS] = useState();
  const [countyMonthlySetupFees, setCountyMonthlySetupFees] = useState();
  const [countyYearlySetupFees, setCountyYearlySetupFees] = useState();

  const countySetupFeeCredit = getCountySetupFeeCredit(
    findCountyLocationData(county_name, "county_code1"),
  ).toFixed(2);

  const temp_space =
    getObjLength(findCountyLocationData(county_name, "county_code1")) &&
    is_temp_space &&
    "mt-4";

  useEffect(() => {
    if (getObjLength(subscriptionPlans) && subscriptionPlans?.success) {
      if ((subscriptionPlans?.data).length > 0) {
        const monthlyPlans = subscriptionPlans?.data?.find(
          (data) => data?.name === "Monthly",
        );
        const yearlyPlans = subscriptionPlans?.data?.find(
          (data) =>
            data?.name === (isEnhancedMonitoring ? "Enhanced" : "Yearly"),
        );
        set_MONTHLY_PLAN(monthlyPlans?.setup_fees);
        set_MONTHLY_PLAN_AMOUNT(monthlyPlans?.amount);
        //remove comments after promocode feature added in admin side
        set_MONTHLY_DISCOUNT_PLAN_AMOUNT(0); //(monthlyPlans?.subscription_discount);
        set_MONTHLY_DISCOUNT_SETUP_AMOUNT(0); //(monthlyPlans?.setup_fee_discount);
        set_MONTHLY_PLAN_PER_MONTH(monthlyPlans.recurring_amount);
        set_MONTHLY_PLAN_RECORDING_FEES(monthlyPlans.recording_fee);
        set_YEARLY_PLAN(yearlyPlans?.amount);
        //remove comments after promocode feature added in admin side
        set_YEARLY_DISCOUNT_PLAN_AMOUNT(0); //(yearlyPlans?.subscription_discount);
        set_YEARLY_PLAN_PER_MONTH(yearlyPlans?.recurring_amount);
        set_YEARLY_SAVINGS(yearlyPlans?.yearly_savings);
        set_FIRST_YEAR_SAVINGS(yearlyPlans?.first_year_savings);
        set_YEARLY_PLAN_RECORDING_FEES(yearlyPlans?.recording_fee);
        setCountyMonthlySetupFees(
          monthlyPlans?.additional_charges?.["setup fees"],
        );
        setCountyYearlySetupFees(
          yearlyPlans?.additional_charges?.["setup fees"],
        );
      }
    }
  }, [subscriptionPlans]);

  return (
    <>
      {plan1 && (
        <div className="card_inner w-100 break-word __monthly_price">
          <div className="d-flex align-items-center mb-4">
            <div
              className="d-flex align-items-start"
              style={{ flexDirection: "column" }}
            >
              <p className="title mb-0">EquityProtect</p>
              <h2 className="subTitle mb-0">
                {isFirstYearFreePricing ? "First Year" : "Monthly"}
              </h2>
            </div>
            <div className="ms-auto">
              <LazyLoadImage
                src={auto_activity}
                alt="auto_activity_zone"
                width="48px"
                height="48px"
              />
              {/* <img
                src={auto_activity}
                alt="auto_activity_zone"
                width="48px"
                height="48px"
              /> */}
            </div>
          </div>
          <hr className="seperator" />
          {isFirstYearFreePricing ? (
            <div className={`pricing_Wrapper text-center`}>
              <div className="bell-land-title-promo">
                <h1 className="free-text pricing-amount">FREE</h1>
                <p className="promo-description">
                  Your First Year of Protection has been Paid for by
                </p>
                <img
                  className="agent_logo"
                  src={brokerDetails?.data?.broker?.logo}
                  width="auto"
                  height="35px"
                  alt="logo"
                />
              </div>
            </div>
          ) : (
            <div
              className={`pricing_Wrapper text-center mt-5 ${
                county_name && "county_pricing_wrapper"
              }`}
            >
              {MONTHLY_DISCOUNT_SETUP_AMOUNT ? (
                <h4
                  className={`flex-container ${
                    fullPage ? "mb-1" : "mb-2 pt-3"
                  }`}
                >
                  <span className="text_strike pe-3">${MONTHLY_PLAN}</span>
                  <span>${MONTHLY_DISCOUNT_SETUP_AMOUNT.toFixed(2)}</span>
                </h4>
              ) : county_name ? (
                <>
                  <h4
                    className={`${
                      fullPage ||
                      getObjLength(
                        findCountyLocationData(county_name, "county_code1"),
                      )
                        ? "mb-1"
                        : "mb-2 pt-3"
                    } ${county_name && "plan_price"}`}
                  >
                    ${(MONTHLY_PLAN_AMOUNT / 100).toFixed(2)}
                  </h4>
                  {getObjLength(
                    findCountyLocationData(county_name, "county_code1"),
                  ) && <p className="caption_texts">Per month, per property</p>}
                </>
              ) : (
                <h4 className={`${fullPage ? "mb-1" : ""} _per_month_price`}>
                  ${(MONTHLY_PLAN_PER_MONTH / 100).toFixed(2)}
                  <span>/month</span>
                </h4>
              )}
              <p className="mb-0">
                {county_name &&
                !getObjLength(
                  findCountyLocationData(county_name, "county_code1"),
                )
                  ? "for the first Month"
                  : ""}
              </p>
              {!county_name ? (
                <p className="one_time_fee">$99.99 one-time setup fee</p>
              ) : MONTHLY_DISCOUNT_PLAN_AMOUNT ? (
                <>
                  <h5 className="mb-0 pt-0">
                    + ${(MONTHLY_DISCOUNT_PLAN_AMOUNT / 100).toFixed(2)} / month
                  </h5>
                  <p>for the first Year</p>
                  <h6 className="mt-3 flex-container">
                    <span className="pe-3 fw-700">
                      + ${(MONTHLY_PLAN_PER_MONTH / 100).toFixed(2)} / month
                      after a year
                    </span>
                  </h6>
                </>
              ) : getObjLength(
                  findCountyLocationData(county_name, "county_code1"),
                ) ? (
                <>
                  {countyMonthlySetupFees && (
                    <>
                      <p className="one_time_fee">
                        ${countyMonthlySetupFees} one-time setup fee
                      </p>
                      <p className="mb-4 caption_texts">
                        For the first year per Property
                      </p>
                    </>
                  )}
                  <p className="one_time_credit">
                    {
                      findCountyLocationData(county_name, "county_code1")
                        ?.county_name
                    }{" "}
                    County Residents receive a <span>one-time</span> Credit of $
                    {countySetupFeeCredit} towards your <span>Set-up</span> Fee.
                  </p>
                  <p className="mb-0 mt-0 itlalic_text caption_texts">
                    {/* Plus $35.00 per property for Recording charges. This is a one time fee. */}
                    + applicable Deposit for recording fee (One time fee)
                  </p>
                </>
              ) : (
                <>
                  <h5 className="mt-3">
                    + ${(MONTHLY_PLAN_PER_MONTH / 100).toFixed(2)} / month
                  </h5>
                  <p className="mb-0 mt-0">+ applicable sales tax</p>
                  <p
                    className={`${
                      fullPage
                        ? "mb-0"
                        : MONTHLY_DISCOUNT_PLAN_AMOUNT
                          ? "mb-2 pb-2"
                          : !county_name
                            ? "mb-0 pb-0"
                            : "mb-4 pb-3"
                    }`}
                  >
                    {/* + <b>{currencyFormatter(LOCAL_RECORDING_FEES)}</b>&nbsp; */}
                    {MONTHLY_PLAN_RECORDING_FEES &&
                      "+ applicable Deposit for recording fee (One time fee)"}
                  </p>
                </>
              )}

              {!county_name && (
                <>
                  <p className="mb-0 mt-0">+ applicable sales tax</p>
                  <p
                    className={`${
                      fullPage
                        ? "mb-0"
                        : MONTHLY_DISCOUNT_PLAN_AMOUNT
                          ? "mb-2 pb-2"
                          : !county_name
                            ? "mb-0 pb-0"
                            : "mb-4 pb-3"
                    }`}
                  >
                    {/* + <b>{currencyFormatter(LOCAL_RECORDING_FEES)}</b>&nbsp; */}
                    {MONTHLY_PLAN_RECORDING_FEES &&
                      "+ applicable Deposit for recording fee (One time fee)"}
                  </p>
                </>
              )}
              {/* <h5 className={""}>${MONTHLY_PLAN}</h5>
            <p className="mb-0">Set-up & Activation Fee</p> */}
              {/* {fullPage && (
              <p
                className="pt-1 mt-2"
                style={{
                  color: "transparent",
                  "-webkit-user-select": "none",
                  "-ms-user-select": "none",
                  "user-select": "none",
                }}
              >
                Savings of ${FIRST_YEAR_SAVINGS} for the first Year and $
                {YEARLY_SAVINGS} every year after.
              </p>
            )} */}
            </div>
          )}

          {!fullPage && !isFirstYearFreePricing && (
            <div className="text-center mt-auto">
              <button
                className={`signin_button protection_bg w-100 px-2 ${
                  county_name ? "mt-5" : "mt-4"
                }`}
                onClick={() => {
                  if (promoCode) {
                    navigate(`${signup_link}?code=${promoCode}`);
                  } else {
                    navigate(signup_link);
                  }
                }}
              >
                GET PROTECTION NOW
              </button>
            </div>
          )}
        </div>
      )}

      {plan2 && (
        <div className="card_inner w-100 break-word">
          <div className="d-flex align-items-center mb-4">
            <div
              className="d-flex align-items-start"
              style={{ flexDirection: "column" }}
            >
              <p className="title mb-0">EquityProtect</p>
              <h2 className="subTitle mb-0">
                {isFirstYearFreePricing
                  ? "Follwing Years"
                  : isEnhancedMonitoring
                    ? "Enhanced Monitoring"
                    : "Yearly"}
              </h2>
            </div>
            <div className="ms-auto">
              <LazyLoadImage
                src={auto_activity1}
                alt="auto_activity_zone"
                width="48px"
                height="48px"
              />
              {/* <img
                src={auto_activity1}
                alt="auto_activity_zone"
                width="48px"
                height="48px"
              /> */}
            </div>
          </div>
          <hr className="seperator" />
          {isFirstYearFreePricing ? (
            <div
              className={`pricing_Wrapper __yearly_price text-center pt-1 ${yearly_spacing} `}
            >
              <div className="bell-land-title-promo">
                <div className="pricing-section">
                  <h1 className="free-text">$99.99</h1>
                  <p className="pricing-description">
                    Per year, per property charged starting Year Two
                  </p>

                  <div className="features-description">
                    <p className="promo-description">
                      Includes comprehensive monthly monitoring of county
                      recorder activity, property sale and rental listings, and
                      dark web alerts. Also features EquityProtect's patented
                      Title Lock technology, which prevents anyone other than
                      you from transferring or borrowing against your
                      property—backed by the SmartPolicy guarantee.
                    </p>
                  </div>
                </div>

                {findAllowedPrefixData(county)?.isFirstYearFreePricing && (
                  <button
                    className={`signin_button protection_bg w-100 px-2 text-uppercase ${
                      county_name ? "mt-5" : "mt-4"
                    }`}
                    onClick={() => {
                      navigate(signup_link);
                    }}
                  >
                    Complete Registration
                  </button>
                )}
              </div>
            </div>
          ) : (
            <div
              className={`pricing_Wrapper __yearly_price text-center pt-1 ${yearly_spacing} ${
                county_name && "county_pricing_wrapper"
              }`}
            >
              {/* {county_name &&
                !getObjLength(
                  findCountyLocationData(county_name, "county_code1"),
                ) && (
                  <p className="mb-0 activation_text">
                    No Set-up or Activation Fee
                  </p>
                )} */}
              {YEARLY_DISCOUNT_PLAN_AMOUNT ? (
                <>
                  <h4 className="mb-1 flex-container text-center">
                    <span className="text_strike pe-3">
                      ${((YEARLY_PLAN || price) / 100).toFixed(2)}
                    </span>
                    <span>
                      ${(YEARLY_DISCOUNT_PLAN_AMOUNT / 100).toFixed(2)}
                    </span>
                  </h4>
                </>
              ) : county_name ? (
                getObjLength(
                  findCountyLocationData(county_name, "county_code1"),
                ) ? (
                  <>
                    <h4 className={`plan_price mb-1 ${temp_space}`}>
                      ${((YEARLY_PLAN || price) / 100).toFixed(2)}
                    </h4>
                    <p className="caption_texts">Per year, per property</p>
                  </>
                ) : (
                  <>
                    <h4 className="plan_price mb-1">
                      ${((YEARLY_PLAN || price) / 100).toFixed(2)}
                    </h4>
                    <p className="mb-0">Per year, per property</p>
                  </>
                )
              ) : (
                <h4 className="mb-1 _per_year_price">
                  $
                  {Number.isFinite(YEARLY_PLAN_PER_MONTH) ? (
                    <>
                      {(YEARLY_PLAN_PER_MONTH / 100).toFixed(2)}
                      <span>/year</span>
                    </>
                  ) : (
                    "-"
                  )}
                </h4>
              )}
              {/* {!county_name && (
                <p className="activation_text pt-1 ">
                  ${PER_MONTH_SAVINGS} per month an annual savings of $
                  {PER_ANNUAL_SAVINGS}
                </p>
              )} */}
              {isEnhancedMonitoring ? null : county_name ? (
                getObjLength(
                  findCountyLocationData(county_name, "county_code1"),
                ) ? (
                  <>
                    {countyYearlySetupFees && (
                      <>
                        <p className="one_time_fee">
                          ${countyYearlySetupFees} one-time setup fee
                        </p>
                        <p className="mb-4 caption_texts">
                          For the first year per Property
                        </p>
                      </>
                    )}
                    <p className="fw-600 text-danger one_time_credit">
                      {
                        findCountyLocationData(county_name, "county_code1")
                          ?.county_name
                      }{" "}
                      County Residents receive a <span>one-time</span> Credit of
                      ${countySetupFeeCredit} towards your <span>Set-up</span>{" "}
                      Fee.
                    </p>
                    <p className="mb-0 mt-0 itlalic_text caption_texts">
                      {/* Plus $35.00 per property for Recording charges. This is a one time fee. */}
                      + applicable Deposit for recording fee (One time fee)
                    </p>
                  </>
                ) : (
                  <>
                    <>
                      <p className="one_time_fee">$99.99 one-time setup fee</p>
                      <p className="mb-4 caption_texts">
                        For the first year per Property
                      </p>
                    </>
                    <p className="fw-600 text-danger one_time_credit">
                      {
                        findCountyLocationData(county_name, "county_code1")
                          ?.county_name
                      }{" "}
                      County Residents receive a <span>one-time</span> Credit of
                      ${countySetupFeeCredit} towards your <span>Set-up</span>{" "}
                      Fee.
                    </p>
                    <p className="mb-0 mt-0 caption_texts">
                      + applicable Deposit for recording fee (One time fee)
                    </p>
                    <p className="mb-0 mt-0">+ applicable sales tax</p>
                  </>
                )
              ) : (
                <p className="one_time_fee">$99.99 one-time setup fee</p>
              )}
              {!isEnhancedMonitoring && !county_name && (
                <>
                  <p className="mb-0 mt-0">+ applicable sales tax</p>
                  <p className="mb-0 w-100">
                    {/*+ <b>{currencyFormatter(LOCAL_RECORDING_FEES)}</b> &nbsp;*/}
                    {YEARLY_PLAN_RECORDING_FEES &&
                      "+ applicable Deposit for recording fee (One time fee)  "}
                  </p>
                  {/* <p className="activation_text pt-1 pb-2">
              {!county_name && `Save $${YEARLY_SAVINGS} every year after!`}
            </p> */}
                </>
              )}
              {isEnhancedMonitoring && (
                <div className="enhanced-monitoring-features text-start">
                  <div className="enhanced-feature-item">
                    <span className="enhanced-feature-icon">✓</span>
                    <div className="enhanced-feature-content">
                      <p className="enhanced-feature-title">
                        County Recorder Property Monitoring
                      </p>
                      <p className="enhanced-feature-desc">
                        Continuously scans official recording data to alert
                        property owners the moment any document is filed against
                        their title.
                      </p>
                    </div>
                  </div>
                  <div className="enhanced-feature-item">
                    <span className="enhanced-feature-icon">✓</span>
                    <div className="enhanced-feature-content">
                      <p className="enhanced-feature-title">
                        Property Listing Site Monitoring
                      </p>
                      <p className="enhanced-feature-desc">
                        Scans public real estate sites to detect suspicious
                        listings and alert you immediately.
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          {!fullPage && !isFirstYearFreePricing && (
            <div className="text-center mt-auto">
              <button
                className={`signin_button protection_bg w-100 px-2 ${
                  county_name ? "mt-5" : "mt-4"
                }`}
                onClick={() => {
                  if (promoCode) {
                    navigate(`${signup_link}?code=${promoCode}`);
                  } else {
                    navigate(signup_link);
                  }
                }}
              >
                GET PROTECTION NOW
              </button>
            </div>
          )}
        </div>
      )}
      <Loader open={statesLoader} />
    </>
  );
};

export default SubscriptionPlansContent;
